export const PROPERTY_MAP_STYLE_OWNER = 'mapbox'
export const PROPERTY_MAP_ROADMAP_STYLE_ID = 'streets-v12'
export const PROPERTY_MAP_SATELLITE_STYLE_ID = 'satellite-streets-v12'

export const PROPERTY_MAP_ROADMAP_STYLE = `mapbox://styles/${PROPERTY_MAP_STYLE_OWNER}/${PROPERTY_MAP_ROADMAP_STYLE_ID}`
export const PROPERTY_MAP_SATELLITE_STYLE = `mapbox://styles/${PROPERTY_MAP_STYLE_OWNER}/${PROPERTY_MAP_SATELLITE_STYLE_ID}`

export const MAPBOX_STATIC_IMAGE_BASE_URL = `https://api.mapbox.com/styles/v1/${PROPERTY_MAP_STYLE_OWNER}/${PROPERTY_MAP_ROADMAP_STYLE_ID}/static`

export const PROPERTY_MAP_SINGLE_MARKER_ZOOM = 14
export const PROPERTY_MAP_ANIMATION_DURATION_MS = 300
export const PROPERTY_MAP_CONTROL_BUTTON_SIZE = 40
export const PROPERTY_MAP_CONTROL_ICON_SIZE = 18
export const PROPERTY_MAP_SNAP_BACK_CONTROL_OFFSET = 10
export const PROPERTY_MAP_SNAP_BACK_CONTROL_NAVIGATION_OFFSET = 100

export const PROPERTY_MAP_COORDINATE_PRECISION = 6
export const MAPBOX_STATIC_IMAGE_MIN_DIMENSION = 1
// Mapbox Static Images API has a maximum dimension of 1280x1280, so we need to normalise the requested image dimensions to fit within this limit while maintaining the aspect ratio.
export const MAPBOX_STATIC_IMAGE_MAX_DIMENSION = 1280
export const PROPERTY_MAP_DEFAULT_STATIC_IMAGE_HEIGHT = 300
export const PROPERTY_MAP_STATIC_IN_VIEW_ROOT_MARGIN = '300px 0px'
export const PROPERTY_MAP_STATIC_AUTO_VIEWPORT_PADDING = 48
export const PROPERTY_MAP_DEFAULT_STATIC_MARKER_IMAGE_ID = 'map-pin'

// Mapbox static marker images are fetched at the display size we want on the map.
export const PROPERTY_MAP_STATIC_MARKER_DEFAULT_DIMENSIONS = { width: 53, height: 66 }
export const PROPERTY_MAP_STATIC_MARKER_IMAGE_DIMENSIONS_BY_ID: Record<string, { width: number, height: number }> = {
  'cruise-pill-icon-pin': { width: 95, height: 39 },
  'cruise-pill-pin': { width: 64, height: 39 },
  'food-pin': PROPERTY_MAP_STATIC_MARKER_DEFAULT_DIMENSIONS,
  'heart-pin': PROPERTY_MAP_STATIC_MARKER_DEFAULT_DIMENSIONS,
  'le-map-pin': { width: 53, height: 56 },
  'map-pin': PROPERTY_MAP_STATIC_MARKER_DEFAULT_DIMENSIONS,
  'moment-pin': PROPERTY_MAP_STATIC_MARKER_DEFAULT_DIMENSIONS,
  'scoopontravel-map-pin': { width: 53, height: 56 },
  'star-pin': PROPERTY_MAP_STATIC_MARKER_DEFAULT_DIMENSIONS,
}
